import {
  call,
  takeLatest,
  put,
} from 'redux-saga/effects';
import { updateCarrier } from '../carrier';
import { CARRIER_FETCH, THEME_FETCH, FEATURE_FETCH } from '../actionTypes';
import api from '../../utils/services';

function* getCarrier(action) {
  let carrierId;
  if (action.carrierId) {
    ({ carrierId } = action);
    const response = yield call(api.carrier, carrierId);
    yield put(updateCarrier(response));
  } else {
    const data = yield call(api.carrier);
    const { id } = data[0];
    carrierId = id;
    // update carrier in redux.
    yield put(updateCarrier(data[0]));
  }
  // once we got the carrier
  // dispatch actions to get the theme and the features.
  yield put({ type: THEME_FETCH, carrierId });
  yield put({ type: FEATURE_FETCH, carrierId });
}

export default function* carrierInfoSaga() {
  yield takeLatest(CARRIER_FETCH, getCarrier);
}
